// Getters (GET*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const DASHBOARD_GET_CHART_DATA = 'DASHBOARD_GET_CHART_DATA';
export const DASHBOARD_GET_DATA = 'DASHBOARD_GET_DATA';
export const DASHBOARD_GET_GRID_DATA = 'DASHBOARD_GET_GRID_DATA';
export const DASHBOARD_GET_IFRAME_URL = 'DASHBOARD_GET_IFRAME_URL';
export const DASHBOARD_GET_TITLE = 'DASHBOARD_GET_TITLE';
export const DASHBOARD_GET_WORKSHEETS = 'DASHBOARD_GET_WORKSHEETS';


// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const DASHBOARD_SET_STATE = 'DASHBOARD_SET_STATE';
export const DASHBOARD_SET_WORKSHEETS = 'DASHBOARD_SET_WORKSHEETS';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const DASHBOARD_DELETE_DATA = 'DASHBOARD_DELETE_DATA';
export const DASHBOARD_UPDATE_DATA = 'DASHBOARD_UPDATE_DATA';
export const DASHBOARD_UPDATE_WORKSHEETS_DATA = 'DASHBOARD_UPDATE_WORKSHEETS_DATA';
